class PTTabs extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', (event) => {
      const button = event.target.closest('[data-pt-tab]');
      if (!button) return;
      const value = button.dataset.ptTab;
      this.querySelectorAll('[data-pt-tab]').forEach((el) => el.setAttribute('aria-selected', String(el === button)));
      this.querySelectorAll('[data-pt-panel]').forEach((panel) => {
        const categories = (panel.dataset.ptPanel || '').split('|');
        panel.hidden = value !== 'all' && !categories.includes(value);
      });
    });
  }
}

if (!customElements.get('pt-tabs')) {
  customElements.define('pt-tabs', PTTabs);
}
